import styled from 'styled-components'
import InvitePeopleField, { InviteButton } from 'components/InvitePeopleField'

export const StyledInviteButton = styled(InviteButton)`
  width: 68px;
`

export const StyledInvitePeopleField = styled(InvitePeopleField)`
  margin-right: 16px;
  max-width: calc(100% - 85px);
`

export const MembersList = styled.div`
  margin-top: 16px;
`
